import React from "react";

import { FormattedMessage } from "react-intl";

import { CwsA } from "cms-web-styleguide/dist/components/CwsA/CwsA";
import { CwsButton } from "cms-web-styleguide/dist/components/CwsButton/CwsButton";
import { CwsModalBody } from "cms-web-styleguide/dist/components/CwsModal/CwsModalBody/CwsModalBody";
import { CwsModalFooter } from "cms-web-styleguide/dist/components/CwsModal/CwsModalFooter/CwsModalFooter";
import { CwsP } from "cms-web-styleguide/dist/components/CwsTypography/CwsP/CwsP";

import { Dropdown } from "../../components/Dropdown/Dropdown";
import { TitleWithImg } from "../../components/TitleWithImg/TitleWithImg";

import styles from "./Banner.module.scss";

const Banner = (props) => {
  const { env, handleLocaleChange, locale, onOpenPopup, onSaveCookies } = props;

  return (
    <section>
      <CwsModalBody>
        <div className={styles["cwc-banner__inner"]}>
          <div className={styles["cwc-banner__row"]}>
            <TitleWithImg />

            <Dropdown env={env} handleLocaleChange={handleLocaleChange} locale={locale} />
          </div>
          <div className={styles["cwc-banner__row"]}>
            <CwsP hideSpacing size="small">
              <FormattedMessage id="banner.description" />
            </CwsP>
          </div>
        </div>
      </CwsModalBody>
      <CwsModalFooter>
        <div className={styles["cwc-banner__buttons"]}>
          <div className={styles["cwc-banner__button"]}>
            <CwsButton onClick={() => onSaveCookies()} width="fluid-mobile">
              <FormattedMessage id="popup.button.agree.to.all" />
            </CwsButton>
          </div>
          <div className={styles["cwc-banner__button"]}>
            <CwsA onClick={onOpenPopup}>
              <FormattedMessage id="banner.link.title" />
            </CwsA>
          </div>
        </div>
      </CwsModalFooter>
    </section>
  );
};

export { Banner };
